import { createAction, handleActions } from "redux-actions";
import {actionMapZoomFeaturesUpdated} from "../Map";

export const initialState = {
  // MapviewHistory component
  historyMax: 20,
  mapViewHistory: [],
  mapViewCurrentIndex: 0,
  // This was changed from a boolean to a counter in order
  // to handle rapidly-dispatched back/forward events.
  // Now it can count them up and back down. Before, a
  // simple true/false would get confused.
  mapViewIgnore: 0,
  mapViewPreserveZoomFeatures: 0,
  mapViewInSlider: false,
};

export const actionMapviewHistoryUpdated = createAction(
  "MISC_MAPVIEW_HISTORY_UPDATED",
);
export const actionMapviewCurrentIndexUpdated = createAction(
  "MISC_MAPVIEW_CURRENT_INDEX_UPDATED",
);
export const actionMapviewIgnoreUpdated = createAction(
  "MISC_MAPVIEW_IGNORE_UPDATED",
);
export const actionMapviewPreserveZoomFeatures = createAction(
  "MISC_MAPVIEW_PRESERVE_ZOOM_FEATURES",
);
export const actionMapviewInSlider = createAction("MISC_MAPVIEW_IN_SLIDER");

export const actionUpdateMapviewHistory = (mapview) => {
  return (dispatch, getState) => {
    const { mapViewHistory, historyMax, mapViewIgnore, mapViewInSlider, mapViewPreserveZoomFeatures } =
      getState().miscReducer;
    if (mapViewIgnore > 0) {
      dispatch(actionMapviewIgnoreUpdated(-1));
      return;
    }
    if (mapViewInSlider) {
      return;
    }

    let newHistory = [...mapViewHistory, mapview];
    newHistory =
      newHistory.length > historyMax
        ? newHistory.slice(newHistory.length - historyMax)
        : newHistory;
    dispatch(actionMapviewHistoryUpdated(newHistory));
    dispatch(actionMapviewCurrentIndexUpdated(newHistory.length - 1));

    if (mapViewPreserveZoomFeatures > 0) {
      // zoomFeaturesUpdated tracks the last building/room/region the user
      // zoomed to (zoomBbox()). mapViewPreserveZoomFeatures can be used to
      // "remember" the last zoom. Otherwise, we purposefully clear it out.
      //
      // Remembering the last zoom is helpful when the user enters
      // print preview mode or changes the print size/orientation. In those
      // cases, we want to re-center the last zoom region.
      dispatch(actionMapviewPreserveZoomFeatures(-1));
    } else {
      // However, if the user adjusts the map view in any other way, we clear
      // out the last-remembered zoom so the print "page" will no longer
      // re-center that region.
      dispatch(actionMapZoomFeaturesUpdated({}));
    }
  };
};

export const miscReducer = handleActions(
  {
    [actionMapviewHistoryUpdated]: (state, action) => {
      return { ...state, mapViewHistory: action.payload };
    },
    [actionMapviewCurrentIndexUpdated]: (state, action) => {
      return { ...state, mapViewCurrentIndex: action.payload };
    },
    [actionMapviewIgnoreUpdated]: (state, action) => {
      const newMapViewIgnore = state.mapViewIgnore + action.payload;
      return { ...state, mapViewIgnore: newMapViewIgnore };
    },
    [actionMapviewPreserveZoomFeatures]: (state, action) => {
      const newMapViewPreserveZoomFeatures = state.mapViewPreserveZoomFeatures + action.payload;
      return { ...state, mapViewPreserveZoomFeatures: newMapViewPreserveZoomFeatures };
    },
    [actionMapviewInSlider]: (state, action) => {
      return { ...state, mapViewInSlider: action.payload };
    },
  },
  initialState,
);
